// @flow
import queryString from 'query-string';
import HashMap from '../protocol/HashMap';
import VideoController from '../video/VideoController';
import { CommentFilterOption } from '../util/Constants';
import UnreadCommentsData from '../queries/annotations/UnreadCommentsData';
import ViewUtil from '../ViewUtil';
import UploadScheduler from '../upload/UploadScheduler';
import { CurrentContextInfo, FileFilters } from './../autogenerated/ZoomBridge';
import { isTreeViewEnable, isFolderNavEnable } from '../util/TreeUtil';
//import {t} from '../i18n/I18n';

import {
  COMMENT_FILTER_BY,
  COMMENTS,
  SHOW_COMMENTS,
  COMMENT_TEXT,
  COLLECTION_METADATA,
  COLLECTION_UPLOAD_JOBS,
  ARE_UPLOADS_DISABLED,
  COLLECTION_ASSETS,
  SELECTED_ASSET,
  REVISIONS,
  VIDEO_CONTROLLER,
  SYNC_VIDEOS,
  PERMISSIONS,
  COLLECTIONS,
  ASSET_SCALE_INFO,
  WAVEPLAYER_COMMENT,
  TOAST,
  URLS,
  REPORTS,
  DRAWING_CANVAS,
  GLOBAL_PROGRESS,
  JOBS,
  SELECTED_COLLECTION,
  EXPANDED_THREAD_IDS,
  OAUTH_LOGOUT_STATE,
  REVIEW_SERVER_AUTH_DATA,
  KEYDOWN_CONFIGS,
  SHOW_METADATA_TIMELINE,
  AI_METADATA,
  IS_CLIPMODE_DRAGGING,
  PROP_NAME_TO_PROP_INFO,
  GROUP_CODE_TO_GROUP_INFO,
  GLOBAL_SPINNER,
  ADV_SRCH_ASSETS,
  ADV_SRCH_COLLECTIONS,
  ADV_SRCH_METADATA,
  PWD,
  DRAGGING_ASSET,
  IS_DRAGGING_FILE,
  KEYFRAME_METADATA,
  CLIP_FROM_TIMELINE,
  NOTIFICATION_INFO,
  ASSET_UPLOAD_JOBS,
  SHOW_UPLOADS,
  UPLOAD_SCHEDULER,
  BREADCRUMB_ASSETS,
  ASSETLIST_PAGE_NUMBER,
  UPLOAD_FINISHED,
  CONTEXT_INFO,
  GLOBAL_SEARCH_INFO,
  CATEGORY_LIST,
  DOWNLOAD_JOBS,
  ASSET_FILTERS,
  FULL_TIME_FORMAT,
  WAVEPLAYER_MODE,
  SHOW_NOTIFICATION_PANEL
} from './Constants';

export default function getInitialState() {
  // t("LOGIN.FIRST_NAME",{name:'Manish'});
  const map: Map<any, any> = new Map();

  // Set more appropriate initial state values here.
  map.set(COLLECTIONS, []);
  map.set(SELECTED_COLLECTION, null);
  map.set(COMMENTS, []);
  map.set(COMMENT_FILTER_BY, CommentFilterOption.UNRESOLVED);
  map.set(SHOW_COMMENTS, true);
  map.set(COMMENT_TEXT, '');
  map.set(COLLECTION_METADATA, new HashMap());
  map.set(COLLECTION_UPLOAD_JOBS, []);
  map.set(ASSET_UPLOAD_JOBS, []);
  map.set(ARE_UPLOADS_DISABLED, false);
  map.set(COLLECTION_ASSETS, []);
  map.set(SELECTED_ASSET, null);
  map.set(REVISIONS, []);
  map.set(VIDEO_CONTROLLER, new VideoController());
  map.set(SYNC_VIDEOS, true);
  map.set(PERMISSIONS, {});
  map.set(ASSET_SCALE_INFO, { scale: 1, range: {} });
  map.set(WAVEPLAYER_COMMENT, null);
  map.set(TOAST, '');
  map.set(URLS, [queryString.parse(location.search)]);
  map.set(REPORTS, []);
  map.set(DRAWING_CANVAS, null);
  map.set(GLOBAL_PROGRESS, false);
  map.set(GLOBAL_SPINNER, false);
  map.set(JOBS, []);
  map.set(UnreadCommentsData.NAME, new UnreadCommentsData());
  map.set(EXPANDED_THREAD_IDS, []);
  map.set(OAUTH_LOGOUT_STATE, false);
  map.set(KEYDOWN_CONFIGS, {});
  map.set(SHOW_METADATA_TIMELINE, true);
  map.set(IS_CLIPMODE_DRAGGING, false);
  map.set(PROP_NAME_TO_PROP_INFO, null);
  map.set(GROUP_CODE_TO_GROUP_INFO, null);
  map.set(ADV_SRCH_ASSETS, []);
  map.set(ADV_SRCH_COLLECTIONS, []);
  map.set(ADV_SRCH_METADATA, null);
  map.set(AI_METADATA, null);
  map.set(KEYFRAME_METADATA, null);
  map.set(REVIEW_SERVER_AUTH_DATA, {});
  map.set(PWD, ViewUtil.getPwd());
  map.set(DRAGGING_ASSET, null);
  map.set(IS_DRAGGING_FILE, false);
  map.set(CLIP_FROM_TIMELINE, false);
  map.set(NOTIFICATION_INFO, {});
  map.set(SHOW_UPLOADS, false);
  map.set(UPLOAD_SCHEDULER, new UploadScheduler());
  // map.set(SHOW_FOLDERNAV_VIEW, isFolderNavEnable());
  // map.set(SHOW_TREE_VIEW, isTreeViewEnable());
  map.set(BREADCRUMB_ASSETS, []);
  map.set(ASSETLIST_PAGE_NUMBER, 0);
  map.set(UPLOAD_FINISHED, null);
  map.set(CONTEXT_INFO, new CurrentContextInfo());
  map.set(GLOBAL_SEARCH_INFO, { active: false, assets: null, totalCount: 0, hasNextPage: false });
  map.set(CATEGORY_LIST, []);
  map.set(DOWNLOAD_JOBS, []);
  map.set(FULL_TIME_FORMAT, false);
  map.set(SHOW_NOTIFICATION_PANEL, false);
  if (FileFilters) {
    const filters = new FileFilters();
    filters.setFileTypes([]);
    filters.setFilter2ValueMap(new HashMap());
    map.set(ASSET_FILTERS, filters);
  }
  map.set(WAVEPLAYER_MODE, new Map());
  return map;
}

//t("LOGIN.SIGN_IN",{});
